import { send } from 'server';

/**
 * Get temp auth token
 * Can be used for getting temp token, in game launching for example.
 * @param {Object} params
 * @param {String} params.userName
 * @param {String} params.casinoName
 * @param {String} [params.serviceType]
 * @param {String} [params.sessionToken]
 * @return {Promise}
 */
export const getTemporaryAuthenticationToken = ({
    userName, casinoName, serviceType = 'GamePlay', sessionToken
}) => send({
    ID: 30001,
    responses: [30002, 30003],
    description: 'Get Temporary Authentication Token',
    userName,
    casinoName,
    serviceType,
    sessionToken
});

export const login = request => send({
    ID: 33036,
    responses: [31002, 31009],
    description: 'Login with existing Session token',
    logoutOnDisconnectBehaviour: 'hierarchical',
    logoutOnDisconnect: true,
    waitingMessages: false,
    ...request
});

export const startWindowSession = ({
    windowSessionId,
    subscriptionTags,
    subscriptionActionTypes,
    subscriptionBalanceTypes,
    subscriptionRequestedPlayerData
}) => send({
    ID: 31127,
    responses: [31128, 31129],
    description: 'Start Window Session',
    name: 'Bonus',
    windowSessionId,
    subscriptionTags,
    subscriptionBalanceTypes,
    subscriptionRequestedPlayerData,
    ...subscriptionActionTypes.length && { subscriptionActionTypes }
});

export const getPlayerSessionInfo = () => send({
    ID: 35763,
    responses: [35764, 35765],
    description: 'Player Session Info'
});

/**
 * Response 31014 is handled as a push message from IMS via notifier
 * @returns {Promise}
 */
export const logout = () => send({
    ID: 31013,
    description: 'Logout'
});

/**
 * End window session on IMS
 * @return {Promise}
 */
export const endWindowSession = windowSessionId => send({
    ID: 31130,
    responses: [31131, 31132],
    description: 'End Window Session',
    windowSessionId
});
